import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { BeanMonitoryExclusion } from 'src/bean/BeanMonitoryExclusion';
import { ExclusaoMonitoriaDialogService } from './exclusao-monitoria-dialog.service';

@Component({
  selector: 'app-exclusao-monitoria-dialog',
  templateUrl: './exclusao-monitoria-dialog.component.html',
  styleUrls: ['../monitoria.component.css'] 
})
export class ExclusaoMonitoriaDialogComponent implements OnInit {

  private readonly CRIADO = 'C';

  public monitoryExclusion:BeanMonitoryExclusion = new BeanMonitoryExclusion(null,null,null,null,null,null,null, null, null, null);

  constructor(
    public dialogRef: MatDialogRef<ExclusaoMonitoriaDialogComponent>,
    public exclusaoMonitoriaDialogService: ExclusaoMonitoriaDialogService,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  excluiuComSucesso = false;

  ngOnInit(): void {

  }

  public formSolicitaExclusao: FormGroup = new FormGroup({
    'motivoExclusao': new FormControl('', [Validators.required]),
    'statusExclusao': new FormControl(this.CRIADO),
    'idUsuarioSolicitacao': new FormControl(this.data.idUsuarioSolicitacao ? this.data.idUsuarioSolicitacao : null, [Validators.required]),
    'idMonitoria': new FormControl(this.data.idMonitoria ? this.data.idMonitoria : null, [Validators.required]),
  })

  public solicitarExclusao() :void {
    const {motivoExclusao} = this.formSolicitaExclusao.value;
    const {statusExclusao} = this.formSolicitaExclusao.value;
    this.monitoryExclusion.exmoDsMotivo = motivoExclusao;
    this.monitoryExclusion.exmoDsStatus = statusExclusao;  
    this.monitoryExclusion.moniIdCdMonitoria = this.data.idMonitoria;
    this.monitoryExclusion.usuaIdCdUsuario = this.data.idUsuarioSolicitacao;
    
    this.exclusaoMonitoriaDialogService.solicitarExclusao(this.monitoryExclusion).toPromise()
    .then((resposta:any) => this.toastr.success('Solicitação de exclusão criada com sucesso!', 'Solicitação de Exclusão'))
    .catch(errorResponse => this.toastr.error(errorResponse?.error?.message, 'ERRO'))

    this.excluiuComSucesso = true;

    this.dialogRef.close(this.excluiuComSucesso);
 
  }


  fecharExcluirMoni(){
    this.dialogRef.close(this.excluiuComSucesso);
  }
 

  

}
